module.exports = __webpack_public_path__ + "img/zhongguoyh.17e4c5f0.png";